import * as React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { EditorUtils, EditorToolsSettings } from '@progress/kendo-react-editor';
import { InsertImageDialog } from './insertImageDialog.jsx';
const imageSettings = EditorToolsSettings.image;

let organizationId = "";
let projectId = "";

export class InsertImage extends React.Component {
    state = { openedDialog: false };
    toggleDialog = () => this.setState({ openedDialog: !this.state.openedDialog });

    render() {
        const { view } = this.props;
        const state = view && view.state;
        const nodeType = state ? state.schema.nodes[imageSettings.node] : undefined;

        return (
            <>
                <Button
                    onClick={this.toggleDialog}
                    disabled={!nodeType || !state || !EditorUtils.canInsert(state, nodeType)}
                    onMouseDown={e => e.preventDefault()}
                    onPointerDown={e => e.preventDefault()}
                    title="Insert Image"
                    {...imageSettings.props}
                />
                {   
                    this.state.openedDialog && view && (
                    <InsertImageDialog
                        key="insertImageDialog"
                        view={view}
                        organizationId={organizationId}
                        projectId={projectId}
                        onClose={this.toggleDialog}
                        imageNode={imageSettings.node}
                    />
                )}
            </>
        );
    }
}

export const setOrganizationId = (value) => {
    organizationId = value;
}

export const setProjectId = (value) => {
    projectId = value;
}